module.exports = __webpack_public_path__ + "img/PS-AlambreTubular.13c252b5.png";